import React from 'react'
import Header from "components/Headers/Header.js";
import { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, CardFooter, Button, Table} from "reactstrap";
import axios from 'axios'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {Link} from 'react-router-dom'
import {Form} from 'react-bootstrap'
import { format } from 'date-fns'; 
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

function AddNewModels() {

    const [loading, setLoading] = useState(true)
    const [cropmodelsoptions, setCropmodelsoptions] = useState([])
    const [crop, setCrop] = useState("")
    const [request, setRequest] = useState([])
    const [loadingsubmit, setLoadingsubmit] = useState(true)
    const [modal, setModal] = useState(false);

    const token = useSelector((state) => state.userLogin.userInfo.token);

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////
    
    const toggleModal = () => setModal(!modal);

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/support/request-add-crop-model-list/`, config);
                
                setCropmodelsoptions(response.data)

            } catch (error) {

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/list-model-not-activated/`, config);
                console.log(response.data)
                setRequest(response.data)
                setCrop(response.data[0].cropname)

            } catch (error) {

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);

    const handleSubmit = async(e) => {

        setLoadingsubmit(false)

        try {

            const config = {
                headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
                }
            };  

            const payload = {
                "crop": crop
            } 
                
            await axios.post(`${process.env.REACT_APP_BACKEND_API}/support/add-new-request-crop-model/`, payload, config);

        } catch (error) {
            console.log(error)
        } finally {
            setLoadingsubmit(true)

            const config = {
                headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
                }
            };  
            
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/support/request-add-crop-model-list/`, config);

            setRequest(response.data)
            toggleModal()
        }

    }

    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):(
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t('Request received')}</h3>
                                </CardHeader>
                                <CardBody>
                                    <>                                   
                                        <Table className="align-items-center table-flush text-center" responsive>
                                            <thead className="thead-light">
                                                <tr>
                                                <th scope="col">{t('Crop Requested')}</th>
                                                <th scope="col">{t('Date of the request')}</th>
                                                <th scope="col">{t('Is completed')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cropmodelsoptions.map((farmer, index) => (
                                                    <tr key={index}>
                                                        <td>{farmer.crop_requested}</td>
                                                        <td>{format(new Date(farmer.created_at), 'PPpp')}</td>
                                                        <td>
                                                            {farmer.completed ? (
                                                                <FaCheckCircle color="green" />
                                                            ) : (
                                                                <FaTimesCircle color="red" />
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>  
                                    </>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t('Request a new crop model')}</h3>
                                </CardHeader>
                                <CardBody>
                                    <Form role="form">
                                        <Form.Group controlId="exampleForm.SelectCustom">
                                            <Form.Label>{t('Select the Crop Models')}</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                onChange={(e)=>setCrop(e.target.value)} 
                                                value={crop}>
                                                    {request.map((farmer, index) => (
                                                        <option key={index} value={farmer.cropname}>
                                                            {farmer.cropname}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group> 
                                    </Form>
                                </CardBody>
                                <CardFooter>
                                    <Row>
                                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-2">
                                            {loadingsubmit ? (
                                                <>
                                                    <Button className="my-4" color="success" type="button" onClick={handleSubmit}>
                                                    {t("Request to add a new crop model")} 
                                                    </Button>
                                                </>
                                            ):(
                                                <>
                                                    <Button color="success" disabled>
                                                    <Spinner size="sm">
                                                        {t("Submitting your request...")}
                                                    </Spinner>
                                                    <span>
                                                        {' '}{t("Submitting your request...")}
                                                    </span>
                                                    </Button>
                                                </>
                                            )}
                                        </Col>
                                        <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-2">
                                            <Link to="/">
                                                <Button color="primary">
                                                    {t('Go back')} <i className="fas fa-rotate-left"></i>
                                                </Button>
                                            </Link>
                                        </Col>  
                                    </Row>
                                </CardFooter>
                            </Card>
                        </Col>
                        <Modal isOpen={modal} toggle={toggleModal}>
                            <ModalHeader toggle={toggleModal}>{t('Your request has been submitted')}</ModalHeader>
                            <ModalBody>
                                <p>{t('A email has been sent to your email.') }</p>
                                <p>{t('One operator will review your request, and send you a email as soon as possible.') }</p>
                            </ModalBody>
                        </Modal>
                    </Row>
                </Container>
            )}
        </div>
    )
}

export default AddNewModels
